import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum TeamRegularFields {
  id = 'id',
  name = 'name',
  archiveDate = 'archiveDate',
  status = 'status',
  startDate = 'startDate',
  endDate = 'endDate',
  updatedOn = 'updatedOn',
  updatedBy = 'updatedBy',
  createdOn = 'createdOn',
  createdBy = 'createdBy',
  summary = 'summary',
  customFields = 'customFields',
  workspaceId = 'WorkspaceId',
  publicName = 'publicName',
  picked = 'picked',
  invited = 'invited',
  accepted = 'accepted',
  declined = 'declined',
  noResponse = 'noResponse',
  noShow = 'noShow',
}

export enum TeamOrderByFields {
  name = 'name',
  archiveDate = 'archiveDate',
  status = 'status',
  startDate = 'startDate',
  endDate = 'endDate',
  updatedOn = 'updatedOn',
  updatedBy = 'updatedBy',
  createdOn = 'updatedOn',
  createdBy = 'createdBy',
}

export const TeamSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(TeamRegularFields.id, '', 'Id'),
  new ItemPickerModel(TeamRegularFields.name, '', 'Team'),
  new ItemPickerModel(TeamRegularFields.publicName, '', 'Public Name'),
  new ItemPickerModel(TeamRegularFields.archiveDate, '', 'Archive Date'),
  new ItemPickerModel(TeamRegularFields.startDate, '', 'Start Date'),
  new ItemPickerModel(TeamRegularFields.endDate, '', 'End Date'),
  new ItemPickerModel(TeamRegularFields.updatedBy, '', 'Updated By'),
  new ItemPickerModel(TeamRegularFields.updatedOn, '', 'Updated On'),
  new ItemPickerModel(TeamRegularFields.createdBy, '', 'Created By'),
  new ItemPickerModel(TeamRegularFields.createdOn, '', 'Created On'),
  new ItemPickerModel(TeamRegularFields.status, '', 'Status'),
  new ItemPickerModel(TeamRegularFields.summary, '', 'Summary'),
  new ItemPickerModel(TeamRegularFields.picked, '', 'Position Status: Picked'),
  new ItemPickerModel(TeamRegularFields.invited, '', 'Position Status: Invited'),
  new ItemPickerModel(TeamRegularFields.accepted, '', 'Position Status: Accepted'),
  new ItemPickerModel(TeamRegularFields.declined, '', 'Position Status: Declined'),
  new ItemPickerModel(TeamRegularFields.noResponse, '', 'Position Status: No Response'),
  new ItemPickerModel(TeamRegularFields.noShow, '', 'Position Status: No Show'),
];
